// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3tUtH","title":"Info_title__2jaRg","links":"Info_links__3nh5y","link":"Info_link__3bvIc","logo":"Info_logo__1wPEF"};